import 'ScssComponents/_popup_voucher.scss';

const voucherPopup = () => {
	const $triggers = document.querySelectorAll('.voucherTrigger');
	const $popup = document.querySelector('.voucherPopup');

	if (!$popup || $triggers.length === 0) return;
	const $closeButton = $popup.querySelector('.voucherPopupClose');

	$triggers.forEach(($trigger) => {
		const hideImg = $trigger.dataset.voucherImage;

		// $trigger.addEventListener('click', (event) => {
		// console.log('cl');
		// event.preventDefault();
		if ($popup) {
			setTimeout(() => {
				$popup.classList.add('popup_voucher--open_state');

				if (hideImg !== undefined) {
					$popup.classList.add('popup_voucher--hidden_img');
				}
			}, 3000);
		}
		// });
	});

	$closeButton.addEventListener('click', (event) => {
		event.preventDefault();
		if ($popup) {
			$popup.classList.remove('popup_voucher--open_state');

			setTimeout(() => {
				$popup.classList.remove('popup_voucher--hidden_img');
			}, 300);
		}
	});
};

export default voucherPopup;
